import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRuleByIdQueryVariables = GraphQLTypes.Exact<{
  workflowRuleId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetWorkflowRuleByIdQueryResult = { __typename?: 'Query' } & {
  workflowRuleById: { __typename?: 'WorkflowRuleType' } & Pick<GraphQLTypes.WorkflowRuleType, 'ruleDefinitionId'> & {
      ruleDefinition: { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
        GraphQLTypes.WorkflowRuleDefinitionType,
        'id' | 'ruleDescription' | 'ruleName'
      > & {
          ruleInputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
          ruleOutputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
        };
      ruleInput: { __typename?: 'RuleInputObjectType' } & Pick<
        GraphQLTypes.RuleInputObjectType,
        | 'collectionCountry'
        | 'countryOfDestination'
        | 'countryOfOrigin'
        | 'deliveryCountry'
        | 'destination'
        | 'incoterms'
        | 'modeOfTransport'
        | 'origin'
        | 'portOfDestination'
        | 'portOfDestinationCountry'
        | 'portOfOrigin'
        | 'portOfOriginCountry'
        | 'shipmentContext'
        | 'shipmentType'
      > & {
          account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
          event?: GraphQLTypes.Maybe<
            Array<GraphQLTypes.Maybe<{ __typename?: 'UserDefinedEventType' } & Pick<GraphQLTypes.UserDefinedEventType, 'id'>>>
          >;
          supplier?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
        };
      ruleOutput: { __typename?: 'RuleOutputObjectType' } & {
        actions?: GraphQLTypes.Maybe<
          Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>
        >;
        consignee?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
        consignor?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
        customerOperationsCoordinator?: GraphQLTypes.Maybe<
          { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
        >;
        customsOperationsCoordinator?: GraphQLTypes.Maybe<
          { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
        >;
        destinationOperationsCoordinator?: GraphQLTypes.Maybe<
          { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
        >;
        notifyParties?: GraphQLTypes.Maybe<Array<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>>;
        originAgent?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
        originOperationsCoordinator?: GraphQLTypes.Maybe<
          { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
        >;
        supplierContacts?: GraphQLTypes.Maybe<Array<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>>>;
      };
    };
};

export const GetWorkflowRuleByIdDocument = gql`
  query getWorkflowRuleById($workflowRuleId: String!) {
    workflowRuleById(workflowRuleId: $workflowRuleId) {
      ruleDefinition {
        id
        ruleDescription
        ruleInputFields {
          component
          hidden
          label
          name
          required
        }
        ruleName
        ruleOutputFields {
          component
          hidden
          label
          name
          required
        }
      }
      ruleDefinitionId
      ruleInput {
        account {
          id
        }
        collectionCountry
        countryOfDestination
        countryOfOrigin
        deliveryCountry
        destination
        event {
          id
        }
        incoterms
        modeOfTransport
        origin
        portOfDestination
        portOfDestinationCountry
        portOfOrigin
        portOfOriginCountry
        shipmentContext
        shipmentType
        supplier {
          id
        }
      }
      ruleOutput {
        actions {
          label
          path
          type
        }
        consignee {
          id
        }
        consignor {
          id
        }
        customerOperationsCoordinator {
          id
        }
        customsOperationsCoordinator {
          id
        }
        destinationOperationsCoordinator {
          id
        }
        notifyParties {
          id
        }
        originAgent {
          id
        }
        originOperationsCoordinator {
          id
        }
        supplierContacts {
          id
        }
      }
    }
  }
`;
